<template>
    <div class="card">
        <div class="card-body">
            <spinner></spinner>
        </div>
    </div>
</template>

<script>

    import spinner from "../components/spinner.vue"
    import { getAPIUrl, getThisUrl } from "@/common/envMixins";
    export const authUrl = `${getAPIUrl()}/Auth?returnUrl=${getThisUrl()}`;

    export default {
        name: 'Loading',
        components: { spinner },
        mounted() {
            //alert("Test");
            var urlParams = new URLSearchParams(location.search);
            var aUrl = authUrl;
            if (urlParams.has('returnUrl')) {
                aUrl = `${getAPIUrl()}/Auth?returnUrl=${urlParams.get('returnUrl')}`;
            }
        
            if (this.$store.state.userInfo.isAuthenticated == false) {
                window.location.replace(aUrl);
            } else {
                this.$router.push("/");
            }
        }
    }
</script>
